import React, { Component, Fragment } from "react"
import { isEmpty, find } from "lodash"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import { connect } from "react-redux"
import styles from "./styles"
import MainAppBar from "../../components/MainAppBar"
import {
  Typography,
  Hidden,
  Button,
  Container,
  Box,
  TextField,
  IconButton,
  Icon,
  Menu,
  MenuItem,
  Input,
} from "@material-ui/core"
import { setClients } from "../../actions/clients"
import {
  getGigsList,
  toggleConfirmGigApplyDialog,
  toggleConfirmSocialIntegrationDialog,
  toggleGigDialog,
  createGigApplication,
  setsearchedGigs,
} from "../../actions/gigs"
import TabBar from "../../components/TabBar"
import "@fullcalendar/daygrid/main.css"
import MaterialTable from "material-table"
import _ from "lodash"

import { convertToAbbr } from "../../lib/states"
import { openSnackBar } from "../../actions/snack-bar"

import ConfirmGigApplyDialog from "../../components/ConfirmGigApplyDialog/index"
import ConfirmSocialIntegrationDialog from "../../components/ConfirmSocialIntegrationDialog/index"
import moment from "moment"

import ActionBar from "../../components/ActionBar"
import { hiddenLoginModal } from "../../actions/authentication"
import { toggleReferCrewDialog } from "../../actions/crew"
import { green } from "@material-ui/core/colors"
import LoadingOverlay from "react-loading-overlay"
import TwitterIcon from "@material-ui/icons/Twitter"
import AddCircleIcon from "@material-ui/icons/AddCircle"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"
import { id } from "date-fns/locale"
class Gigs extends Component {
  state = {
    sort: null,
    height: null,
    eventPopoverPosition: {
      top: 0,
      left: 0,
    },
    popover: {
      anchor: null,
      func: () => "",
    },
    activeGig: null,
    working: false,
    searchLocation: "",
    searchPosition: "",
    searchMenuAnchorEl: null,
    searchedGigs: [],
  }

  componentWillMount() {
    this.setState({ working: true })
    this.loadGigsList()
    this.setState({ working: false })
  }

  loadGigsList = async () => {
    await this.props.dispatch(getGigsList())
    const { gigsList } = this.props
    if (gigsList) {
      this.setState({
        searchedGigs: gigsList,
      })
    }
  }

  componentWillUnmount() {
    this.props.dispatch(setClients())
  }

  applyForPosition = async (event, shootData) => {
    this.props.dispatch(toggleConfirmGigApplyDialog(true))
    this.props.dispatch(toggleGigDialog({ open: true, gig: shootData }))
  }

  shareOnTwitter = async (event, shootData) => {
    // const { authentication } = this.props
    this.props.dispatch(toggleConfirmSocialIntegrationDialog(true))
    this.props.dispatch(toggleGigDialog({ open: true, gig: shootData }))
  }

  setPopover = (e, func) => {
    this.setState({
      popover: {
        anchor: e.currentTarget,
        func: {
          $set: func,
        },
      },
    })
  }

  apply = async () => {
    const { gig, authentication } = this.props
    await this.setState({ working: true })
    const gigData = {
      user_id: authentication.authenticatedUser.id,
      shoot_id: gig.shoot_id,
      role_id: gig.role_id,
      position_id: gig.position_id,
      user_name:
        authentication.authenticatedUser.first_name +
        " " +
        authentication.authenticatedUser.last_name,
    }
    this.props
      .dispatch(createGigApplication(gigData))
      .then(res => {
        this.loadGigsList()
        this.props.dispatch(toggleConfirmGigApplyDialog(false))
        this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({ message: "Already Applied on the Gig" })
        )
      })
    await this.setState({ working: false })
  }

  searchGigsByPosition = async value => {
    const { props } = this
    const { gigsList } = props
    let searchResults
    this.setState({
      searchPosition: value,
    })
    if (value) {
      searchResults = gigsList.filter(
        n => n.name && n.name.toLowerCase().includes(value.toLowerCase())
      )
      if (searchResults) {
        this.setState({ searchedGigs: searchResults })
      } else {
        this.setState({ searchedGigs: [] })
      }
    } else {
      this.setState({ searchedGigs: gigsList })
    }
  }

  searchGigsByLocation = async value => {
    const { props } = this
    const { gigsList } = props
    let searchResults
    this.setState({
      searchLocation: value,
    })
    if (value) {
      searchResults = gigsList.filter(
        n =>
          (JSON.parse(n.location).city &&
            JSON.parse(n.location)
              .city.toLowerCase()
              .includes(value.toLowerCase())) ||
          (_.head(convertToAbbr(JSON.parse(n.location).state)) &&
            _.head(convertToAbbr(JSON.parse(n.location).state))
              .abbr.toLowerCase()
              .includes(value.toLowerCase()))
      )
      if (searchResults) {
        this.setState({ searchedGigs: searchResults })
      } else {
        this.setState({ searchedGigs: [] })
      }
    } else {
      this.setState({ searchedGigs: gigsList })
    }
  }

  // refer crew member
  handleReferCrewMember = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.dispatch(toggleReferCrewDialog(true))
      })
      .catch(err => console.log({ err }))
  }

  handleOpenSearchMenu = event => {
    this.setState({
      searchMenuAnchorEl: event.currentTarget,
    })
  }
  handleCloseSearchMenu = () => {
    this.setState({
      searchMenuAnchorEl: null,
    })
  }

  render() {
    const { props } = this
    const { gigsList, classes, accessLevel, authentication } = props
    const {
      activeGig,
      working,
      searchLocation,
      searchPosition,
      searchMenuAnchorEl,
      searchedGigs,
    } = this.state

    const components = {
      Action: props => {
        if (props.action.icon === "apply") {
          return (
            <span style={{ display: "flex", alignItems: "center" }}>
              {authentication.authenticatedUser.id &&
              props.data.applicants.length > 0 &&
              find(
                props.data.applicants,
                applicant =>
                  applicant.user_id === authentication.authenticatedUser.id &&
                  applicant.position_id === props.data.position_id
                    ? true
                    : false
              ) ? (
                <Fragment>
                  {/* WEB VIEW */}
                  <Hidden smDown>
                    <Typography
                      variant="primary"
                      className={classes.gigsAppliedAction}
                    >
                      Applied!
                    </Typography>
                  </Hidden>
                  {/* MOBILE VIEW */}
                  <Hidden mdUp>
                    <IconButton
                      onClick={event => props.action.onClick(event, props.data)}
                    >
                      <CheckCircleIcon className={classes.checkIcon} />
                    </IconButton>
                  </Hidden>
                </Fragment>
              ) : (
                <Fragment>
                  {/* WEB VIEW */}
                  <Hidden smDown>
                    <Button
                      onClick={event => props.action.onClick(event, props.data)}
                      color="primary"
                      variant="contained"
                      style={{ margin: "5px" }}
                      size="small"
                      fullWidth
                      classes={{ label: classes.actions }}
                    >
                      Raise My Hand
                    </Button>
                  </Hidden>
                  {/* MOBILE VIEW */}
                  <Hidden mdUp>
                    <IconButton
                      onClick={event => props.action.onClick(event, props.data)}
                    >
                      <AddCircleIcon className={classes.checkIcon} />
                    </IconButton>
                  </Hidden>
                </Fragment>
              )}
            </span>
          )
        }

        if (props.action.icon === "share") {
          return (
            <span style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                onClick={event => props.action.onClick(event, props.data)}
              >
                <TwitterIcon className={classes.twitterIcon} />
              </IconButton>
            </span>
          )
        }
      },
    }

    return (
      <LoadingOverlay active={working} spinner text="Applying on the Gig...">
        <Fragment>
          {getCurrentHost() === "crewmama" ? (
            <CrewMamaAppBarComponent history={this.props.history} />
          ) : (
            <Fragment>
              <MainAppBar />
              <TabBar history={this.props.history} />
            </Fragment>
          )}

          {/* WEB VIEW */}
          <Hidden smDown>
            <ActionBar
              buttonChildren={classes => {
                return (
                  <Fragment>
                    {!authentication.authenticatedUser.id && (
                      <Button
                        onClick={() => {
                          localStorage.clear()
                          this.props.history.push("/login")
                        }}
                        color="primary"
                        variant="contained"
                        style={{ marginRight: "8px" }}
                      >
                        Login / Register
                      </Button>
                    )}

                    {accessLevel !== 1 && (
                      <React.Fragment>
                        <Button
                          onClick={() => this.handleReferCrewMember()}
                          color="primary"
                          variant="contained"
                        >
                          Refer Crew Member
                        </Button>
                      </React.Fragment>
                    )}
                  </Fragment>
                )
              }}
            />
          </Hidden>

          {/* MOBILE VIEW */}
          <Hidden mdUp>
            <div
              style={{
                display: "flex",
                paddingTop: "15px",
                marginLeft: "15px",
                backgroundColor: "#f8f8f8",
              }}
            >
              {!authentication.authenticatedUser.id && (
                <Button
                  onClick={() => {
                    localStorage.clear()
                    this.props.history.push("/login")
                  }}
                  color="primary"
                  variant="contained"
                  style={{ marginRight: "8px" }}
                >
                  Login / Register
                </Button>
              )}

              {accessLevel !== 1 && (
                <React.Fragment>
                  <Hidden smDown>
                    <Button
                      onClick={() => this.handleReferCrewMember()}
                      color="primary"
                      variant="contained"
                    >
                      Refer Crew Member
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() => this.handleReferCrewMember()}
                      color="primary"
                      variant="contained"
                    >
                      Refer Crew
                    </Button>
                  </Hidden>
                </React.Fragment>
              )}
            </div>
          </Hidden>

          <Container
            style={{
              maxWidth: "100%",
              backgroundColor: "#f8f8f8",
              paddingTop: "20px",
            }}
          >
            {/* WEB VIEW */}
            <Hidden smDown>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {searchedGigs &&
                  searchedGigs.length > 0 && (
                    <div className={this.props.classes.resultsWrapper}>
                      <Typography
                        variant="h6"
                        className={this.props.classes.resultsNumber}
                      >
                        {searchedGigs && searchedGigs.length}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        className={this.props.classes.resultsText}
                      >
                        Gigs Found
                      </Typography>
                    </div>
                  )}

                <div style={{ display: "flex" }}>
                  <Box className={classes.adeskGigsSearchLocation}>
                    <TextField
                      value={searchLocation}
                      onChange={e => this.searchGigsByLocation(e.target.value)}
                      label="Search Location"
                      // className={
                      //   getCurrentHost() === "crewmama"
                      //     ? classes.crewGigsTableLeft
                      //     : ""
                      // }
                    />
                  </Box>

                  <Box style={{ width: "200px" }}>
                    <TextField
                      value={searchPosition}
                      // className={
                      //   getCurrentHost() === "crewmama"
                      //     ? classes.crewGigsTableRight
                      //     : ""
                      // }
                      onChange={e => this.searchGigsByPosition(e.target.value)}
                      label="Search Position"
                    />
                  </Box>
                </div>
              </div>
            </Hidden>

            {/* MOBILE VIEW */}
            <Hidden mdUp>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {searchedGigs &&
                  searchedGigs.length > 0 && (
                    <div className={this.props.classes.resultsWrapper}>
                      <Typography
                        variant="p"
                        style={{
                          fontSize: "1rem",
                          fontWeight: 600,
                        }}
                      >
                        {searchedGigs && searchedGigs.length} Gigs Found
                      </Typography>
                    </div>
                  )}

                <div style={{ display: "flex" }}>
                  {/* MOBILE VIEW */}
                  <IconButton onClick={e => this.handleOpenSearchMenu(e)}>
                    <Icon>search</Icon>
                  </IconButton>
                  <Menu
                    anchorEl={searchMenuAnchorEl}
                    open={Boolean(searchMenuAnchorEl)}
                    onClose={() => this.handleCloseSearchMenu()}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem>
                      <TextField
                        value={searchLocation}
                        onChange={e =>
                          this.searchGigsByLocation(e.target.value)
                        }
                        label="Search Location"
                      />
                    </MenuItem>
                    <MenuItem>
                      <TextField
                        value={searchPosition}
                        onChange={e =>
                          this.searchGigsByPosition(e.target.value)
                        }
                        label="Search Position"
                      />
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </Hidden>

            {/* WEB VIEW */}
            <Hidden smDown>
              <MaterialTable
                title="Gigs"
                data={
                  searchedGigs &&
                  searchedGigs.map(x => {
                    if (!x.tableData) {
                      x.tableData = {}
                    }
                    return x
                  })
                }
                columns={[
                  // { title: "", field: "img" },
                  { title: "Position", field: "name" },
                  {
                    title: "Location",
                    field: "location",
                    render: rowData => {
                      try {
                        const location = JSON.parse(rowData.location)
                        let city = location.city || "TBD"
                        let stateAbbr
                        if (location.country !== "United States") {
                          stateAbbr = location.state || "TBD"
                        } else {
                          stateAbbr =
                            _.head(convertToAbbr(location.state)).abbr ||
                            location.state ||
                            "TBD"
                        }

                        return <span>{`${city}, ${stateAbbr}`}</span>
                      } catch (error) {
                        console.log("error u need", error)
                        return <span>TBD</span>
                      }
                    },
                  },
                  {
                    title: "Date",
                    field: "start_date",
                    render: rowData => (
                      <span>
                        {moment(rowData.start_date).format("MMM DD, YYYY")}
                      </span>
                    ),
                  },
                  {
                    title: "Status",
                    field: "status",
                    render: rowData => (
                      <span>
                        {rowData.status && rowData.status.toUpperCase()}
                      </span>
                    ),
                  },
                ]}
                components={components}
                actions={[
                  {
                    icon: "apply",
                    tooltip: "Save User",
                    onClick: (event, rowData) =>
                      this.applyForPosition(null, rowData),
                  },
                  {
                    icon: "share",
                    tooltip: "Share on Twitter",
                    onClick: (event, rowData) =>
                      this.shareOnTwitter(null, rowData),
                  },
                ]}
                options={{
                  actionsColumnIndex: -1,
                  pageSizeOptions: [25, 50, 100],
                  pageSize: 25,
                  search: false,
                  showTitle: false,
                  toolbar: false,
                  actionsCellStyle: {
                    display: "flex",
                    justifyContent: "flex-end",
                  },
                }}
                isLoading={working ? true : false}
                classes={{
                  actions: classes.actions,
                }}
              />
            </Hidden>

            {/* Mobile VIEW */}
            <Hidden mdUp>
              <MaterialTable
                title="Gigs"
                data={
                  searchedGigs &&
                  searchedGigs.map(x => {
                    if (!x.tableData) {
                      x.tableData = {}
                    }
                    return x
                  })
                }
                columns={[
                  { title: "Position", field: "name" },
                  {
                    title: "Location",
                    field: "location",
                    render: rowData => {
                      try {
                        const location = JSON.parse(rowData.location)
                        let city = location.city || "TBD"
                        let stateAbbr
                        if (location.country !== "United States") {
                          stateAbbr = location.state || "TBD"
                        } else {
                          stateAbbr =
                            _.head(convertToAbbr(location.state)).abbr ||
                            location.state ||
                            "TBD"
                        }

                        return <span>{`${city}, ${stateAbbr}`}</span>
                      } catch (error) {
                        console.log("error u need", error)
                        return <span>TBD</span>
                      }
                    },
                  },
                ]}
                components={components}
                actions={[
                  {
                    icon: "apply",
                    tooltip: "Save User",
                    onClick: (event, rowData) =>
                      this.applyForPosition(null, rowData),
                  },
                  {
                    icon: "share",
                    tooltip: "Share on Twitter",
                    onClick: (event, rowData) =>
                      this.shareOnTwitter(null, rowData),
                  },
                ]}
                options={{
                  actionsColumnIndex: -1,
                  pageSizeOptions: [25, 50, 100],
                  pageSize: 25,
                  search: false,
                  showTitle: false,
                  toolbar: false,
                  actionsCellStyle: {
                    display: "flex",
                    justifyContent: "flex-end",
                  },
                }}
                isLoading={working ? true : false}
                classes={{
                  actions: classes.actions,
                }}
              />
            </Hidden>
          </Container>
          <ConfirmGigApplyDialog
            gig={activeGig}
            working={working}
            onApplyGig={() => this.apply()}
            history={this.props.history}
          />

          <ConfirmSocialIntegrationDialog
            gig={activeGig}
            working={working}
            onApplyGig={() => this.apply()}
            history={this.props.history}
          />
        </Fragment>
      </LoadingOverlay>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    gigsList: state.gigs.gigs,
    gig: state.gigs.gigDetails,
    searchedClientList: state.clients.searchedClients,
    users: state.misc.users,
    roles: state.misc.roles,
    shoots: state.shoots.shoots,
    activeCompany: state.companies.activeCompany,
    shootsLength: state.shoots.shootsLength,
    accessLevel: state.companies.accessLevel,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(Gigs)
